export default __webpack_public_path__ + "static/media/MSM.5782eace.png";